import {
  FaBalanceScale,
  FaDollarSign,
  FaEye,
  FaFlask,
  FaHandsHelping,
  FaLightbulb,
  FaLeaf,
  FaRecycle,
} from 'react-icons/fa';
import { const_routes } from '../../app/helpers/const_routes';
import { selectTechnology } from '../../app/actions/technologyActions';
import { selectAlternative } from '../../app/actions/alternativeActions';
import { selectExperience } from '../../app/actions/experienceActions';
import { selectInnovation } from '../../app/actions/innovationActions';
import { selectAssistance } from '../../app/actions/assistanceActions';
import { selectFinancial } from '../../app/actions/financialActions';
import { selectVision } from '../../app/actions/visionActions';
import { selectRegulation } from '../../app/actions/regulationActions';
import PreviewTechnology from '../specialist-technology/PreviewTechnology';
import ViewTechnology from '../specialist-technology/ViewTechnology';
import PreviewAlternative from '../specialist-alternative/PreviewAlternative';
import ViewAlternative from '../specialist-alternative/ViewAlternative';
import PreviewExperience from '../specialist-experience/PreviewExperience';
import ViewExperience from '../specialist-experience/ViewExperience';
import PreviewInnovation from '../specialist-innovation/PreviewInnovation';
import ViewInnovation from '../specialist-innovation/ViewInnovation';
import PreviewAssistance from '../specialist-assistance/PreviewAssistance';
import ViewAssistance from '../specialist-assistance/ViewAssistance';
import PreviewFinancial from '../specialist-financial/PreviewFinancial';
import ViewFinancial from '../specialist-financial/ViewFinancial';
import ViewVision from '../specialist-vision/ViewVision';
import ViewRegulation from '../specialist-regulation/ViewRegulation';

export const MODULE_INTEGRATION_META = {
  technology: {
    route: const_routes.ROUTE_TECHNOLOGY,
    responseKey: 'technology',
    nameField: 'name',
    selectAction: selectTechnology,
    PreviewComponent: PreviewTechnology,
    ViewComponent: ViewTechnology,
    Icon: FaFlask,
    labelKey: 'semanticSearch.module.technology',
    listStateKey: 'technologiesS',
    selectedCountKey: 'numberTechnologySelected',
    moreThanOneKey: 'moreThanOneIsSelected',
  },
  alternative: {
    route: const_routes.ROUTE_ALTERNATIVE,
    responseKey: 'alternative',
    nameField: 'name',
    selectAction: selectAlternative,
    PreviewComponent: PreviewAlternative,
    ViewComponent: ViewAlternative,
    Icon: FaRecycle,
    labelKey: 'semanticSearch.module.alternative',
    listStateKey: 'alternativesS',
    selectedCountKey: 'numberAlternativeSelected',
    moreThanOneKey: 'moreThanOneIsSelected',
  },
  experience: {
    route: const_routes.ROUTE_EXPERIENCE,
    responseKey: 'experience',
    nameField: 'name',
    selectAction: selectExperience,
    PreviewComponent: PreviewExperience,
    ViewComponent: ViewExperience,
    Icon: FaLeaf,
    labelKey: 'semanticSearch.module.experience',
    listStateKey: 'experiencesS',
    selectedCountKey: 'numberExperienceSelected',
    moreThanOneKey: 'moreThanOneIsSelected',
  },
  innovation: {
    route: const_routes.ROUTE_INNOVATION,
    responseKey: 'innovation',
    nameField: 'name',
    selectAction: selectInnovation,
    PreviewComponent: PreviewInnovation,
    ViewComponent: ViewInnovation,
    Icon: FaLightbulb,
    labelKey: 'semanticSearch.module.innovation',
    listStateKey: 'innovationsS',
    selectedCountKey: 'numberInnovationSelected',
    moreThanOneKey: 'moreThanOneIsSelected',
  },
  assistance: {
    route: const_routes.ROUTE_ASSISTANCE,
    responseKey: 'assistance',
    nameField: 'name',
    selectAction: selectAssistance,
    PreviewComponent: PreviewAssistance,
    ViewComponent: ViewAssistance,
    Icon: FaHandsHelping,
    labelKey: 'semanticSearch.module.assistance',
    listStateKey: 'assistancesS',
    selectedCountKey: 'numberAssistanceSelected',
    moreThanOneKey: 'moreThanOneIsSelected',
  },
  financial: {
    route: const_routes.ROUTE_FINANCIAL,
    responseKey: 'financial',
    nameField: 'name',
    selectAction: selectFinancial,
    PreviewComponent: PreviewFinancial,
    ViewComponent: ViewFinancial,
    Icon: FaDollarSign,
    labelKey: 'semanticSearch.module.financial',
    listStateKey: 'financialsS',
    selectedCountKey: 'numberFinancialSelected',
    moreThanOneKey: 'moreThanOneIsSelected',
  },
  vision: {
    route: const_routes.ROUTE_VISION,
    responseKey: 'visionObject',
    nameField: 'theme',
    selectAction: selectVision,
    PreviewComponent: ViewVision,
    ViewComponent: ViewVision,
    Icon: FaEye,
    labelKey: 'semanticSearch.module.vision',
    listStateKey: 'visionsS',
    selectedCountKey: 'numberVisionSelected',
    moreThanOneKey: 'moreThanOneIsSelected',
  },
  regulation: {
    route: const_routes.ROUTE_REGULATION,
    responseKey: 'regulation',
    nameField: 'name',
    selectAction: selectRegulation,
    PreviewComponent: ViewRegulation,
    ViewComponent: ViewRegulation,
    Icon: FaBalanceScale,
    labelKey: 'semanticSearch.module.regulation',
    listStateKey: 'regulationsS',
    selectedCountKey: 'numberRegulationSelected',
    moreThanOneKey: 'moreThanOneIsSelected',
  },
};

export const getInboxRecordPath = (moduleKey) => {
  if (moduleKey === 'vision' || moduleKey === 'regulation') {
    return `/end-user-search/view-${moduleKey}`;
  }
  return `/end-user-search/preview-${moduleKey}`;
};

export const getSelectedOriginItems = (moduleState, moduleKey) => {
  const meta = MODULE_INTEGRATION_META[moduleKey];
  if (!meta || !moduleState) return [];
  const list = moduleState[meta.listStateKey] || [];
  return list
    .filter((row) => row.isSelected)
    .slice(0, 9)
    .map((row) => ({
      id: row.id,
      name: row[meta.nameField] || row.name || row.theme || null,
    }));
};
